import Bill, {ApiBill, DetailBillFilters, BillFilters} from '@/model/Bill';
import {CombinedApiResponse, doApiRequest, Method, Module} from '..';
import {parseGenericFilters} from '../meta/filters';
import {ApiSortOrder, ApiSortsDerived} from '../meta/odata';

export enum ResourceRechnung {
  Rechnungen = '/Rechnungen',
}

export async function getBills(
    filters: BillFilters,
    sorts: ApiSortsDerived<ApiBill>,
    limit: number | null = null,
    skip: number = 0,
): Promise<CombinedApiResponse<Bill[]>> {
  const response = await doApiRequest<ApiBill[]>({
    method: Method.Get,
    resource: ResourceRechnung.Rechnungen,
    module: Module.Rechnung,
    filters: parseGenericFilters({...filters}),
    select: new Set([
      'RechnungNr',
      'RechnDatum',
      'Bezeichnung',
      'GesamtNetto',
      'GesamtMwSt',
      'GesamtBrutto',
    ]),
    sorts,
    skip,
    limit,
  });

  return [response.Data.map((p) => Bill.fromApi(p)),
    response.CountAll];
}

export async function getDetailBill(
    filters: DetailBillFilters,
): Promise<CombinedApiResponse<Bill | null>> {
  const response = await doApiRequest<ApiBill[]>({
    method: Method.Get,
    resource: ResourceRechnung.Rechnungen,
    module: Module.Rechnung,
    filters: parseGenericFilters({...filters}),
    expand: {
      ['AusgangsRechnungPositionen']: {
        select: new Set(['PosNr']),
        sorts: [['PosNr', ApiSortOrder.Asc]],
        expand: {
          ['Artikel']: {
            select: new Set([
              'ArtikelNr',
              'ArtikelBezeichnung1',
              'ArtikelBezeichnung2',
            ]),
          },
          ['Einheit']: {
            select: new Set(['Menge', 'Einheit']),
          },
          ['Preise']: {
            select: new Set(['EinheitsPreis', 'NettoBetrag']),
          },
        },
      },
    },
  });

  return response.Data.length ? [Bill.fromApi(response.Data[0])] : [null];
}
